"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
class Result {
    static success(result) {
        return new ResultSuccess(result);
    }
    static failure(error) {
        return new ResultFailure(error);
    }
}
exports.Result = Result;
class ResultSuccess extends Result {
    constructor(value) {
        super();
        this.value = value;
        Object.freeze(this);
    }
    getOrThrow() {
        return this.value;
    }
    getOrNull() {
        return this.value;
    }
    getOrUndefined() {
        return this.value;
    }
    errOrNull() {
        return null;
    }
    swap() {
        return new ResultFailure(this.value);
    }
    map(f) {
        return new ResultSuccess(f(this.value));
    }
    mapError(f) {
        return new ResultSuccess(this.value);
    }
    flatMap(f) {
        return f(this.value);
    }
    fold(onSuccess, onFailure) {
        return onSuccess(this.value);
    }
    toPromise() {
        return Promise.resolve(this.value);
    }
    toJson() {
        return { success: this.value };
    }
}
class ResultFailure extends Result {
    constructor(error) {
        super();
        this.error = error;
        Object.freeze(this);
    }
    getOrThrow() {
        throw this.error;
    }
    getOrNull() {
        return null;
    }
    getOrUndefined() {
        return undefined;
    }
    errOrNull() {
        return this.error;
    }
    swap() {
        return new ResultSuccess(this.error);
    }
    map(f) {
        return new ResultFailure(this.error);
    }
    mapError(f) {
        return new ResultFailure(f(this.error));
    }
    flatMap(f) {
        return new ResultFailure(this.error);
    }
    fold(onSuccess, onFailure) {
        return onFailure(this.error);
    }
    toPromise() {
        return Promise.reject(this.error);
    }
    toJson() {
        return { failure: this.error };
    }
}
//# sourceMappingURL=result.js.map